import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CostService {

  constructor(
    protected httpClient: HttpClient,
  ) { }
  async getCostByJobId(jobId: string){
	  
    const result: any = await this.httpClient.get(`plan/api/business/cost/queryByJobId/${jobId}`).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }
  async getCostTypeList() {
    const result: any = await this.httpClient.get('plan/api/business/costType/queryAll').toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }
  async getCostType(typeId: string){
    const params = new HttpParams()
      .set('typeId', typeId);
    const result: any = await this.httpClient.get('plan/api/business/costType/queryByTypeId',
      { params }).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }
  async addCost(cost: any) {
    return await this.httpClient.post('plan/api/business/cost/add', cost).toPromise();
  }
  async updateCost(cost: any) {
    const result: any = await this.httpClient.put('plan/api/business/cost/update', cost).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }
}
